/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ACSApiConfiguration, ACSApiConfigurationParams } from './acs-api-configuration';

import { ACSLobbyService } from './services/acs-lobby.service';
import { ACSPractitionerService } from './services/acs-practitioner.service';
import { ACSQueueService } from './services/acs-queue.service';
import { ACSVoipService } from './services/acs-voip.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ACSLobbyService,
    ACSPractitionerService,
    ACSQueueService,
    ACSVoipService,
    ACSApiConfiguration
  ],
})
export class ACSModule {
  static forRoot(params: ACSApiConfigurationParams): ModuleWithProviders<ACSModule> {
    return {
      ngModule: ACSModule,
      providers: [
        {
          provide: ACSApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ACSModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ACSModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
